import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { OwnCreatorProfileGuard } from "src/app/core/guard/own-creator-profile.guard";

export const content: Routes = [
  {
    path: "home",
    loadComponent: () =>
      import("src/app/components/landing-page/landing-page.component").then(
        (m) => m.LandingPageComponent,
      )},
  {
    path: "auth",
    loadChildren: () =>
      import("../../features/auth/auth.module").then((m) => m.AuthModule)},
  {
    path: "account",
    loadChildren: () =>
      import("../../components/account/account.module").then(
        (m) => m.AccountModule,
      )},
  {
    path: "shop",
    loadChildren: () =>
      import("../../components/shop/shop.module").then((m) => m.ShopModule)},
  {
    path: "faq",
    loadComponent: () =>
      import("src/app/features/informational/faq/faq.component").then(
        (m) => m.FaqComponent,
      )},
  {
    path: "terms-and-conditions",
    loadComponent: () =>
      import(
        "src/app/features/informational/terms-and-conditions/terms-and-conditions.component"
      ).then((m) => m.TermsAndConditionsComponent)},
  {
    path: "privacy-policy",
    loadComponent: () =>
      import(
        "src/app/features/informational/privacy-policy/privacy-policy.component"
      ).then((m) => m.PrivacyPolicyComponent)},
  {
    path: "creators",
    loadComponent: () =>
      import(
        "../../features/streamer/screens/streamers/streamers.component"
      ).then((m) => m.StreamersComponent)},
  {
    path: "404",
    loadComponent: () =>
      import("src/app/core/error/screens/generic-error/generic-error.component").then(
        (m) => m.GenericErrorComponent,
      ),
  },
  {
    path: ":name/edit",
    canActivate: [AuthGuard, OwnCreatorProfileGuard],
    loadComponent: () =>
      import(
        "../../features/streamer/screens/streamer-detail/streamer-detail.component"
      ).then((m) => m.StreamerDetailComponent)},
  {
    path: ":name/:action",
    loadComponent: () =>
      import(
        "../../features/streamer/screens/streamer-detail/streamer-detail.component"
      ).then((m) => m.StreamerDetailComponent)},
  {
    path: ":name",
    loadComponent: () =>
      import(
        "../../features/streamer/screens/streamer-detail/streamer-detail.component"
      ).then((m) => m.StreamerDetailComponent)},
  {
    path: ":name/products/:id",
    loadComponent: () =>
      import(
        "../../features/streamer/screens/streamer-product/streamer-product.component"
      ).then((m) => m.StreamerProductComponent)}];
